import {IconButton, InputBase, Paper, styled, Tooltip} from "@mui/material";
import {useDispatch} from "react-redux";
import React, {useEffect, useRef, useState} from "react";
import {ApiUrl} from "../utils/portal-urls";
import {handleHttpResponse} from "../utils/http-helpers";
import {addLatestBatch, batchOnRefresh} from "../features/allBatchesSlice";
import {StyledDivider} from "../NuccSpecialtyValueSet/NuccSpecialtyValueSetPagePasteURLPanel";
import KeyboardReturnIcon from "@mui/icons-material/KeyboardReturn";
import SaveIcon from "@mui/icons-material/Save";
import {pink} from "@mui/material/colors";
import RefreshIcon from "@mui/icons-material/Refresh";
import ShowSnackbar from "../utils/ShowSnackbar";
import {CustomBackdrop} from "../utils/customStyles";

/**
 * @date: 2022-08-11
 * @author: Kevin Hsiau <khsiau@max.md>
 * @copy: (C) Copyright 2022 MaxMD Corporation, All Rights Reserved.
 */


const StyledPaper = styled(Paper) ({
    padding: '2px 4px',
    display: 'flex',
    alignItems: 'center',
    marginTop: '10px',
})

export default function SuffixPagePasteURLPanel (props) {
    const dispatch = useDispatch();
    const [suffixUrl, setSuffixUrl] = useState('');
    const [snackbarMsg, setSnackbarMsg] = useState({open: false, msg: '', msgLv: ''});
    const [loading, setLoading] = useState(false);
    const [reset, setReset] = useState(new Date().getTime());
    const formRef = useRef();


    useEffect(() => {
        getLink();
    }, [reset])

    const handleSubmit = async (event) => {
        event.preventDefault();
        const importUrl = event.target.url.value;
        if (!importUrl) {
            console.error("No url provided")
            setSnackbarMsg({open: true, msg: 'No URL provided', msgLv: 'warning'});
            return;
        }
        const requestOptions = {
            method: 'POST',
            header: { 'Content-Type': 'text/plain' },
            body: importUrl
        }
        console.info(requestOptions);

        try {
            setLoading(true);
            const res = await fetch(ApiUrl.ExternalSource.importSuffix, requestOptions);
            const data = await handleHttpResponse(res);
            dispatch(addLatestBatch({type: 'suffix', 'id': data.id, 'batch': data}));
            dispatch(batchOnRefresh());
        } catch (err) {
            console.error('Failed to import suffix task: ' + err)
            setSnackbarMsg({open: true, msg: 'Failed to Import New Task', msgLv: 'error'})
        } finally {
            setLoading(false);
        }
    }

    const getLink = async () => {
        const url = ApiUrl.ExternalSource.getLink.getPath('VS-Suffix-URL')

        try {
            setLoading(true);
            const res = await fetch(url);
            const data = await handleHttpResponse(res);
            setSuffixUrl(data.value);
        } catch (err) {
            console.error("Failed to get Link " + err)
            setSnackbarMsg({open: true, msg: 'Failed to get link', msgLv: 'error'});
        } finally {
            setLoading(false);
        }
    }

    const handleSaveLink = async () => {
        const url = ApiUrl.ExternalSource.saveLink.getPath('VS-Suffix-URL', 'Database');
        const requestOption = {
            method: 'POST',
            headers: {'Content-Type': 'text/plain'},
            body: suffixUrl
        }

        try {
            setLoading(true);
            const res = await fetch(url, requestOption);
            const data = await handleHttpResponse(res);
            setSnackbarMsg({ open: true, msg: `Successfully save the link: ${suffixUrl}`, msgLv: 'success'});
            console.log("Successfully save the link: " + data.value)
        } catch (err) {
            console.error(err);
            setSnackbarMsg({ open: true, msg: `Failed to save the link: ${suffixUrl}`, msgLv: 'error'});
        } finally {
            setLoading(false);
        }
    }

    const handleReset = () => {
        // setSuffixUrl("https://qa-rr-fhir.maxmddirect.com/ValueSet/e7dec57d-b939-4ecd-b200-6174326b7959?_format=json")
        setReset(new Date().getTime());
    }

    const handleChange = (e) => {
        const { value } = e.target;
        setSuffixUrl(value);
    }

    return (
        <div style={{marginBottom: '10px'}}>
            <StyledPaper
                component="form"
                elevation={3}
                onSubmit={handleSubmit}
                ref={formRef}
            >
                <InputBase
                    sx={{ ml: 1, flex: 1}}
                    value={suffixUrl ?? ""}
                    name="url"
                    autoComplete="off"
                    onChange={handleChange}
                />
                <StyledDivider orientation="vertical" />
                <Tooltip title="Start the Import Process" arrow>
                    <IconButton
                        type="submit"
                        sx={{ p: '10px'}}
                        aria-label="search"
                    >
                        <KeyboardReturnIcon color='primary'/>
                    </IconButton>
                </Tooltip>
                <StyledDivider orientation="vertical" />
                <Tooltip title='Save the link' arrow>
                    <IconButton onClick={handleSaveLink}>
                        <SaveIcon sx={{ color: pink[300]}}/>
                    </IconButton>
                </Tooltip>
                <StyledDivider orientation="vertical" />
                <Tooltip title="Reset the CSV File Url">
                    <IconButton onClick={handleReset}>
                        <RefreshIcon />
                    </IconButton>
                </Tooltip>
            </StyledPaper>
            <ShowSnackbar open={snackbarMsg.open} close={(c) => setSnackbarMsg(c)} msg={snackbarMsg} />
            <CustomBackdrop open={loading} />
        </div>
    )
}